import React from 'react'
import _ from 'lodash'
import format from 'date-fns/format'
import { reduceMetadata } from '~/tools/mll/helpers'
import SocialHandle from '~/components/SocialHandles';
import './index.css'

class PersonDetail02 extends React.PureComponent {
	renderFighterDetail(label, value) {
		return (
			<div className="detail">
				<span className="detail-header">{label}</span>
				<span className="detail-info">{value || 'N/A'}</span>
			</div>
		)
	}

	render() {
		const items = _.get(this.props, 'data.contentData[0].gist', {})
		const metadataMap = reduceMetadata(_.get(items, 'metadata', []))
		const {
			firstName,
			lastName,
			imageGist,
			height,
			weight,
			dob,
			birthPlace,
			twitterUrl,
			instagramUrl,
			body,
			facebookUrl,
			teams,
		} = items

		return (
			<div className="person-detail-02">
				<div
					className="player-container"
					style={{
						backgroundImage: `url(${imageGist._32x9 ||
							require('~/assets/images/pfl-fighter-bg.jpg')})`,
					}}>
					<div className="player-banner">
						<div className="player-info">
							<div className="player-title">
								<div className="player-team-logo">
									{imageGist._1x1 && <img src={imageGist._1x1} alt="team logo" />}
								</div>
								<div className="player-fullname">
									<span>{firstName}</span>
									<span>{lastName}</span>
								</div>
							</div>
							<div className="player-record site-color">{metadataMap.mma_record}</div>
							<div className="player-score">
								{metadataMap.pfl_record ? `(${metadataMap.pfl_record})` : ''}
							</div>
						</div>

						<div className="player-wrapper">
							<div className="player-avatar">
								<img src={imageGist._3x4 || require('~/assets/images/avatar.png')} alt="avatar" />
							</div>
							<div className="player-details">
								<div className="personal-info">
									<div className="info-row physical">
										{this.renderFighterDetail('WEIGHT DIVISION', teams[0].gist.title)}
										{this.renderFighterDetail('HEIGHT', height)}
										{this.renderFighterDetail('WEIGHT', weight)}
									</div>
									<div className="info-row origin">
										{this.renderFighterDetail('BIRTHDAY', dob === null? '' : format(dob.split("T")[0], 'MM/DD/YY'))}
										{this.renderFighterDetail('HOMETOWN', birthPlace)}
										{this.renderFighterDetail('POINTS', metadataMap.points)}
									</div>
								</div>

								<div className="social-handles">
									<SocialHandle url={twitterUrl} icon={"ion-social-twitter"}/>
									<SocialHandle url={facebookUrl} icon={"ion-social-facebook"}/>
									<SocialHandle url={instagramUrl} icon={"ion-social-instagram"}/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="bio" dangerouslySetInnerHTML={{ __html: body }} />
			</div>
		)
	}
}

export default PersonDetail02
